/*!
 * Chieh-Han Chang v20211004
 * Copyright 2019-2021
 * Licensed under Tonghe 2021 Tonghe Marketing Co.,Ltd .
 */

$(document).ready(function() {
    //當前視窗寬度為wdth
    wdth = $(window).width();

    //設定響應式斷點
    mediawdth_desktop = 1270
    mediawdth_tablet = 768


    if (wdth < mediawdth_desktop) {
        screenmode = 2;

    } else {
        screenmode = 0;
    }

    // Run after webpage load finished
    searchbar();
    backtotop();
    menutogglecontrol();
    Navbartoggle();
    sitenavshrink();
    sidenavGoFunction()

    // niceScroll_initial()
    policyblock();


    // Custom element setting
    style_checkbox();

    var selectnameA = "#customselect1";
    style_select(selectnameA);


    // For RWD JS running & specific page JS running
    RUNFUNCRWD();
    JSPAGEcontrol(); //note:run only once

})

$(window).resize(function() {
    wdth = $(window).width();
    RUNFUNCRWD();
});




//RUN func() when switch to desktop or mobile device
//screenmode=0代表已調整為手機版  =1代表已調整為平板版  =2代表已調整為電腦版
function RUNFUNCRWD() {

    if (wdth < mediawdth_tablet) {
        if (screenmode != 0) {
            screenheight = $(window).innerHeight();

            //調整成手機版後要run的func

            $('.opentoggle').siblings('ul').slideUp();

            sitenavshrink();

            screenmode = 0;
            console.log("JS程式-已執行運行手機版");

        }
    } else if (wdth < mediawdth_desktop) {
        if (screenmode != 1) {
            screenheight = $(window).innerHeight();

            //調整成平板版後要run的func

            $('.opentoggle').siblings('ul').slideUp();

            sitenavshrink();
            screenmode = 1;
            console.log("JS程式-已執行運行平板版");
        }
    } else {
        if (screenmode != 2) {
            screenheight = $(window).innerHeight();

            //調整成電腦版後要run的func
            $('.opentoggle').siblings('ul').show();
            $('.navitem-group').removeClass('js-open')
            $('.screenmask').removeClass('screenmask--active');
            $('.wrapper-search').removeClass('is-graduallyshow');
            $('.menu-toggle')
                .attr({
                    'aria-expanded': 'false',
                    'aria-label': '開啟選單'
                })
                .find('span').removeClass('menu-toggle__span--active');
            $('.navhead ul').removeClass('h100');
            $('.navhead-a-active').removeClass('navhead-a-active');
            $('.sticker-triangle-active').removeClass('sticker-triangle-active');

            sitenavshrink();

            screenmode = 2;
            console.log("JS程式-已執行運行電腦版");
        }
    }
}

function JSPAGEcontrol() {

    //在index.html才執行
    if ($currentpage == "INDEX") {

        Slick_initial($currentpage);
        smallwindow_index_OpenControl();

    }

    if ($currentpage == "MEMBER" || $currentpage == "GUIDELINE") {
        inputTYPEcheck();
    }


    if ($currentpage == "ABOUT" || $currentpage == "NEWS" || $currentpage == "LESSONINFORMATION" || $currentpage == "SCHOOL" || $currentpage == "VENUE" || $currentpage == "TRAFFIC" || $currentpage == "CONTACT" || $currentpage == "PRICELIST" || $currentpage == "SITEMAP") {
        Slick_initial($currentpage);
    }


    if ($currentpage == "VENUE") {
        smallwindow_OpenControl()
    }



}

// new WOW().init();
wow = new WOW({
    boxClass: 'wow', // default
    animateClass: 'animated', // default
    offset: 160, // default
    mobile: true, // default
    live: true // default
})
wow.init();



// 點擊hamburger bar後
function menutogglecontrol() {
    function setMenuToggleState(isOpen) {
        var $toggle = $('.menu-toggle');
        $toggle.attr({
            'aria-expanded': isOpen ? 'true' : 'false',
            'aria-label': isOpen ? '關閉選單' : '開啟選單'
        });
        if (isOpen) {
            $toggle.find('span').addClass('menu-toggle__span--active');
        } else {
            $toggle.find('span').removeClass('menu-toggle__span--active');
        }
    }

    $('.menu-toggle').off('click.menuToggle').on('click.menuToggle', function(e) {
        e.preventDefault();
        $('.navitem-group').toggleClass('js-open');
        var isOpen = $('.navitem-group').hasClass('js-open');
        setMenuToggleState(isOpen);

        if (isOpen) {
            $('.screenmask').addClass('screenmask--active');
        } else if (!$('.wrapper-search').hasClass('is-graduallyshow')) {
            $('.screenmask').removeClass('screenmask--active');
        }
    });

    $('.screenmask').off('click.menuToggle').on('click.menuToggle', function() {
        $(this).removeClass('screenmask--active');
        $('.navitem-group').removeClass('js-open');
        setMenuToggleState(false);
        $('.wrapper-search').removeClass('is-graduallyshow');
    });
}


//Navbar 次選單opentoggle（手機 slideDown/Up；桌機 show + .navhead-active）
function Navbartoggle() {
    function isMobileNav() {
        return wdth < mediawdth_desktop;
    }

    function setToggleLabel($btn, expanded) {
        if (!$btn || !$btn.length) {
            return;
        }
        var name = $btn.siblings('a').first().text().trim();
        $btn.attr({
            'aria-expanded': expanded ? 'true' : 'false',
            'aria-label': (expanded ? '收合' : '展開') + '「' + name + '」子選單'
        });
    }

    function isNavheadOpen($li) {
        return $li.hasClass('navhead-active') || $li.hasClass('sub-navhead-active');
    }

    function closeNavhead($li) {
        var $btn = $li.children('.opentoggle');
        var $ul = $li.children('ul');
        if (isMobileNav()) {
            $ul.stop(true, true).slideUp();
        }
        $li.removeClass('navhead-active sub-navhead-active');
        $btn.find('.sticker-triangle').removeClass('sticker-triangle-active sub-navhead__sticker-triangle-active');
        $li.children('a').removeClass('navhead-a-active sub-navhead-a-active');
        setToggleLabel($btn, false);
    }

    function openNavhead($li) {
        var $btn = $li.children('.opentoggle');
        var $ul = $li.children('ul');
        if (!$ul.length) {
            return;
        }

        $li.siblings('li').each(function() {
            closeNavhead($(this));
        });

        if (isMobileNav()) {
            $ul.stop(true, true).slideDown();
        } else {
            $ul.stop(true, true).show();
        }

        if ($li.hasClass('sub-navhead')) {
            $btn.find('.sticker-triangle').addClass('sub-navhead__sticker-triangle-active');
            $li.addClass('sub-navhead-active');
            $li.children('a').addClass('sub-navhead-a-active');
        } else {
            $btn.find('.sticker-triangle').addClass('sticker-triangle-active');
            $li.addClass('navhead-active');
            $li.children('a').addClass('navhead-a-active');
        }
        setToggleLabel($btn, true);
    }

    function toggleNavhead($li) {
        if (isNavheadOpen($li)) {
            closeNavhead($li);
        } else {
            openNavhead($li);
        }
    }

    $('.opentoggle').each(function() {
        setToggleLabel($(this), false);
    });

    // 用委派，避免重複綁定；只靠 click（Enter/Space 會觸發 button 的 click）
    $('.navbar').off('click.navOpen', '.opentoggle').on('click.navOpen', '.opentoggle', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleNavhead($(this).closest('li'));
    });

    // 桌機：點選單外關閉；Esc 關閉
    $(document).off('click.navToggle').on('click.navToggle', function(e) {
        if (isMobileNav()) {
            return;
        }
        if (!$(e.target).closest('.navhead').length) {
            $('.navbar .navhead').each(function() {
                closeNavhead($(this));
            });
        }
    });

    $(document).off('keydown.navToggle').on('keydown.navToggle', function(e) {
        if (e.key !== 'Escape') {
            return;
        }
        $('.navbar .navhead').each(function() {
            closeNavhead($(this));
        });
    });
}



// Searchbar
function searchbar() {

    $('.navbar__searchbtn').click(function() {
        if ($('.wrapper-search').hasClass('is-graduallyshow')) {
            $('.wrapper-search').removeClass('is-graduallyshow');
            if ($('.navitem-group').hasClass('js-open')) {} else {
                $('.screenmask').removeClass('screenmask--active');
            }
        } else {
            $('.screenmask').addClass('screenmask--active');
            $('.wrapper-search').addClass('is-graduallyshow');
        }
    })
    $('.searchclose').click(function() {
        $('.wrapper-search').removeClass('is-graduallyshow');
        if ($('.navitem-group').hasClass('js-open')) {} else {
            $('.screenmask').removeClass('screenmask--active');
        }
    })
}


//  backtotop, transfer the window to topside
function backtotop() {
    if ($('#back-to-top').length) {
        var $btn = $('#back-to-top');
        var scrollTrigger = 100, // px
            backToTop = function() {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    $btn.addClass('show').attr('tabindex', '0');
                } else {
                    $btn.removeClass('show').attr('tabindex', '-1');
                }
            };
        $btn.attr('tabindex', '-1');
        backToTop();
        $(window).on('scroll', function() {
            backToTop();
        });
        $btn.on('click', function(e) {
            e.preventDefault();
            // button 會取得焦點；滾動中若因隱藏而 visibility:hidden，瀏覽器會為焦點反跳，導致無法回頂
            this.blur();
            $('html, body').stop(true).animate({
                scrollTop: 0
            }, 700, 'swing');
        });
    }
}


//Save original News' title and content
function Save_newsdata() {
    nbcount = $(".newsbox").length;
    newsbox__title_content = [];
    newsbox__text_content = [];

    pccount = $(".productbox-index__text").length;
    productbox_index__text_content = [];

    var j = 1;
    var k = 1;

    // 首頁新聞box
    $('.newsbox').each(function() {
        $(this).attr('id', 'nb' + j);
        j++;
    })

    // 首頁產品box
    $('.productbox-index').each(function() {
        $(this).attr('id', 'pc' + k);
        k++;
    })


    for (let i = 0; i < nbcount; i++) {
        newsbox__title_content[i] = $('#nb' + (i + 1)).find('.newsbox__title').text();
        newsbox__text_content[i] = $('#nb' + (i + 1)).find('.newsbox__context').text();
    }

    for (let i = 0; i < pccount; i++) {
        productbox_index__text_content[i] = $('#pc' + (i + 1)).find('.productbox-index__text').text();

    }

}

//News context too long will be cut
function textlengthcut() {

    // 新聞box
    if ($('.newsbox').hasClass('news__newsbox')) {

        if (wdth < mediawdth_desktop) {
            // Run for .newsbox in news.html page (mobile & tablet)
            for (let i = 0; i < nbcount; i++) {

                if (newsbox__title_content[i].length > 22) {
                    var newsbox__title_cut = newsbox__title_content[i].slice(0, 22);
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_content[i]);
                }
                if (newsbox__text_content[i].length > 80) {
                    var newsbox__text_cut = newsbox__text_content[i].slice(0, 80);
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_content[i]);
                }
            }
        } else {
            // Run for .newsbox in news.html page (desktop)
            for (let i = 0; i < nbcount; i++) {
                if (newsbox__title_content[i].length > 22) {
                    var newsbox__title_cut = newsbox__title_content[i].slice(0, 22);
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_cut + "...");
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_content[i]);
                }
                if (newsbox__text_content[i].length > 80) {
                    var newsbox__text_cut = newsbox__text_content[i].slice(0, 80);
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_content[i]);
                }
            }
        }
    } else {
        if (wdth < mediawdth_tablet) {
            // Run for .newsbox in index.html page (mobile)
            for (let i = 0; i < nbcount; i++) {

                if (newsbox__title_content[i].length > 28) {
                    var newsbox__title_cut = newsbox__title_content[i].slice(0, 28);
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_content[i]);
                }

                if (newsbox__text_content[i].length > 80) {
                    var newsbox__text_cut = newsbox__text_content[i].slice(0, 80);
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_content[i]);
                }
            }
        } else {
            // Run for .newsbox in index.html page (tablet & desktop)
            for (let i = 0; i < nbcount; i++) {

                if (newsbox__title_content[i].length > 28) {
                    var newsbox__title_cut = newsbox__title_content[i].slice(0, 28);
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__title').text(newsbox__title_content[i]);
                }

                if (newsbox__text_content[i].length > 80) {
                    var newsbox__text_cut = newsbox__text_content[i].slice(0, 80);
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_cut + "...")
                } else {
                    $('#nb' + (i + 1)).find('.newsbox__context').text(newsbox__text_content[i]);
                }
            }
        }
    }

    //產品主分類box .productbox-index__text
    if (wdth < mediawdth_tablet) {
        // Run for .productbox_index__text in index.html page (mobile)
        for (let i = 0; i < pccount; i++) {
            if (productbox_index__text_content[i].length > 55) {
                var productbox_index__text_cut = productbox_index__text_content[i].slice(0, 55);
                $('#pc' + (i + 1)).find('.productbox-index__text').text(productbox_index__text_cut + "...")
            } else {
                $('#pc' + (i + 1)).find('.productbox-index__text').text(productbox_index__text_content[i])
            }

        }
    } else {
        // Run for .productbox_index__text in index.html page (desktop & tablet)
        for (let i = 0; i < pccount; i++) {
            if (productbox_index__text_content[i].length > 55) {
                var productbox_index__text_cut = productbox_index__text_content[i].slice(0, 55);
                $('#pc' + (i + 1)).find('.productbox-index__text').text(productbox_index__text_cut + "...")
            } else {
                $('#pc' + (i + 1)).find('.productbox-index__text').text(productbox_index__text_content[i])
            }
        }
    }

}



//Slick initial
function Slick_initial(nowpage) {

    if (nowpage == "INDEX") {
        //-- 首頁 Jumbotron
        $('.slick-jumbotron').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });

        //-- 首頁 主題展示
        $('.slick-themedisplay').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: 1489,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: true,
                }
            }, {
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: true,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });

        //-- 首頁 最新快訊
        $('.slick-newsarea').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });

        //-- 首頁 場館介紹
        $('.slick-venueintro').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            fade: true,
            cssEase: 'linear',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });
    }



    if ($('.slick-banner').length > 0) {
        $('.slick-banner').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });
    }

    if ($('.slick-pagebanner').length > 0) {
        $('.slick-pagebanner').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });
    }

    if ($('.slick-news').length > 0) {
        $('.slick-news').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });
    }

    if ($('.slick-activityphotos').length > 0) {
        $('.slick-activityphotos').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3500,
            speed: 1500,
            pauseOnHover: true,
            pauseOnFocus: true,
            draggable: true,
            arrows: true,
            dots: false,
            dotsClass: 'slick-dots',
            //has customized at slick-theme.css
            cssEase: 'ease',
            responsive: [{
                breakpoint: mediawdth_desktop,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                }
            }, {
                breakpoint: mediawdth_tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }]
        });
    }

    // 使用者點 prev／next 後停止該輪播自動播放
    bindSlickStopAutoplayOnArrow();
    // 讓 slide 容器不進 Tab 順序（焦點留給內部連結／按鈕）
    bindSlickSlideOutOfTabOrder();
}

function bindSlickStopAutoplayOnArrow() {
    $(document).off('click.slickStopAutoplay', '.slick-prev, .slick-next')
        .on('click.slickStopAutoplay', '.slick-prev, .slick-next', function() {
            var $slider = $(this).closest('.slick-slider');
            if (!$slider.length || !$slider.hasClass('slick-initialized')) {
                return;
            }
            $slider.slick('slickPause');
            $slider.slick('slickSetOption', 'autoplay', false, false);
        });
}

function demoteSlickSlideTabIndex($slider) {
    $slider.find('.slick-slide').attr('tabindex', '-1');
}

function scheduleDemoteSlickSlideTabIndex($slider) {
    // Slick postSlide 順序：afterChange → 之後才 initADA（又把 slide 設回 tabindex=0）
    // 所以用 setTimeout 等到 initADA 跑完再蓋回 -1
    setTimeout(function() {
        demoteSlickSlideTabIndex($slider);
    }, 0);
}

function bindSlickSlideOutOfTabOrder() {
    $(document)
        .off('afterChange.slickSlideTab breakpoint.slickSlideTab reInit.slickSlideTab', '.slick-slider')
        .on('afterChange.slickSlideTab breakpoint.slickSlideTab reInit.slickSlideTab', '.slick-slider', function() {
            scheduleDemoteSlickSlideTabIndex($(this));
        });

    // 若焦點還是落到 slide 本身，改送到內部第一個可聚焦元件
    $(document)
        .off('focusin.slickSlideTab', '.slick-slide')
        .on('focusin.slickSlideTab', '.slick-slide', function(e) {
            if (e.target !== this) {
                return;
            }
            var $target = $(this)
                .find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])')
                .filter(':visible')
                .first();
            $(this).attr('tabindex', '-1');
            if ($target.length) {
                $target.trigger('focus');
            }
        });

    $('.slick-initialized').each(function() {
        scheduleDemoteSlickSlideTabIndex($(this));
    });
}

// Flexslider initial
function Flexslider_initial() {
    if ($('.flexslider').length > 0) {
        //>0，避免找不到執行失敗而導致後續js無法執行
        $('.flexslider').flexslider({
            animation: "slide",
            controlNav: "thumbnails",
            directionNav: false,
        });
    }
};



//Sitenav shrink when scrolldown
function sitenavshrink() {

    $header = $(".topbar");

    if (wdth < mediawdth_desktop) {
        $header.removeClass("topbar--shrink");

    } else {
        $header.removeClass("topbar--mobile-shrink");
    }

    $(window).on('scroll', function() {
        var scrollDistance = $(window).scrollTop();
        // 手機版navbar點開時,即使捲動 topbar也不會縮小
        if ($('.navitem-group').hasClass('js-open')) {} else {
            if (wdth < mediawdth_desktop) {
                if (scrollDistance > 100) {
                    $header.addClass("topbar--mobile-shrink");
                } else {
                    $header.removeClass("topbar--mobile-shrink");
                }
            } else {
                if (scrollDistance > 100) {
                    $header.addClass("topbar--shrink");
                } else {
                    $header.removeClass("topbar--shrink");
                }
            }
        }

    })

}

function style_checkbox() {
    $('.inquirylist__item').click(function() {
        if ($(this).find('input').prop('checked') == true) {
            $(this).removeClass('bg-color--gray')
            $(this).addClass('bg-color--primary')
            $(this).removeClass('color--contentblack')
            $(this).addClass('color--white')
            $(this).find('.inquirylist__checkbox::before').css('visibility', 'visible')
            $(this).find('.inquirylist__checkbox::after').css('visibility', 'visible')
        } else {
            $(this).removeClass('bg-color--primary')
            $(this).addClass('bg-color--gray')
            $(this).removeClass('color--white')
            $(this).addClass('color--contentblack')
        }
    })
}

    currentoperationControl();

    function currentoperationControl() {
        function setCurrentoperationState(isOpen) {
            var $btn = $('.currentoperation__btn');
            $btn.attr({
                'aria-expanded': isOpen ? 'true' : 'false',
                'aria-label': isOpen ? '縮合場館人數' : '展開場館人數'
            });
            if (isOpen) {
                $btn.find('i').removeClass('is-upside-down');
            } else {
                $btn.find('i').addClass('is-upside-down');
            }
        }

        // 縮合／展開按鈕
        $('.currentoperation__btn').off('click.currentoperation').on('click.currentoperation', function(e) {
            e.preventDefault();
            if ($('.currentoperation--mobile').hasClass('js-currentoperation--open')) {
                $('.currentoperation--mobile').removeClass('js-currentoperation--open');
                $('.currentoperation--mobile').addClass('js-currentoperation--close');
                $(this).siblings('.currentoperation__body').slideUp();
                document.cookie = 'currentoperation_close=true; max-age=259200; path=/;';
                setCurrentoperationState(false);
            } else {
                $('.currentoperation--mobile').removeClass('js-currentoperation--close');
                $('.currentoperation--mobile').addClass('js-currentoperation--open');
                $(this).siblings('.currentoperation__body').slideDown();
                document.cookie = 'currentoperation_close=false; max-age=259200; path=/;';
                setCurrentoperationState(true);
            }
        });

        // Cookie 檢查目前開關狀態
        if (getCookieByName('currentoperation_close') === "true") {
            $('.currentoperation__body').slideUp();
            $('.currentoperation--mobile').removeClass('js-currentoperation--open');
            $('.currentoperation--mobile').addClass('js-currentoperation--close');
            setCurrentoperationState(false);
        } else {
            $('.currentoperation--mobile').removeClass('js-currentoperation--close');
            $('.currentoperation--mobile').addClass('js-currentoperation--open');
            setCurrentoperationState(true);
        }
    }

function sidenavGoFunction(){
    $('#sidenav-goBtn').click(function(){
        if($('#sidenav-select').val()!==''){
            window.location.href = $('#sidenav-select').val();
        }else{

        }
    })
}


function style_select(custumSelect) {
    $(custumSelect).find($('.slt-style').hide());
    var select_totalnum = $(custumSelect).find('.slt-style').find('.slt-style__option').length;
    var j = 0; // id初始值
    var idArrar = [];
    if ($(custumSelect).find('.slt-style-show').text().length == 0) {
        $(custumSelect).find('.slt-style-show').html($(custumSelect).find('.slt-style__option').eq(0).html());
    }
    // 將個別__option的id傳給select裡的option
    $(custumSelect).find('.slt-style__option').each(function() {
        idArrar[j] = $(this).attr('id');
        j++;
    })

    for (let i = 0; i < select_totalnum; i++) {
        $(custumSelect).find('.slt-style').next().append('<option value="' + idArrar[i] + '">' + idArrar[i] + '</option>')
    }

    $(custumSelect).find('.slt-style-show').click(function() {
        //點選單時檢查自己是否為展開, 若是則關自己, 若不是則其他人的選單先關再開自己
        if ($(this).next().css('display') == "none") {
            $('.slt-style').slideUp();
            $('.slt-style').siblings('.slt-styleoutter__arrow').removeClass('is-upside-down');
            $(this).next().slideDown();
        } else {
            $(this).next().slideUp();
        }
        $(custumSelect).find('.slt-styleoutter__arrow').toggleClass('is-upside-down');

    })

    $(custumSelect).find('.slt-style__option').click(function() {
        $(this).parent().slideToggle();
        $(custumSelect).find('.slt-styleoutter__arrow').toggleClass('is-upside-down');
        var select_text = $(this).text();
        var select_id = $(this).attr('id');
        $(custumSelect).find('.slt-style-show').text(select_text);
        $(custumSelect).find('.slt-style').next().children().removeAttr('selected', '');
        $(custumSelect).find('.slt-style').next().children().each(function() {
            if ($(this).attr('value') == select_id) {
                $(this).attr('selected', '');
            }
        })
        $(custumSelect).find('.slt-style').next().change();

        //function works in mall.js
        pbdetail_newprice_update();
    })
}

function inputTYPEcheck() {

    $('input[type="tel"]').change(function() {
        if (isNaN($(this).val())) {
            alert("＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 輸入的電話號碼請為數字半形唷！：）")
            $(this).val("")
        }
    });


    //E-MAIL格式檢查
    $('input[type="email"]').change(function() {
        $Emailchecking = IsEmail($(this).val())
        if ($Emailchecking == false) {
            alert("＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 請填寫正確的E-MAIL格式唷！：）");
            $(this).val("");
            $(this).blur(); //離開焦點
        }
    })

    //電話格式檢查
    $('#telephone').change(function() {
        var regex = /^(\d{2,3}-?|\(\d{2,3}\))\d{3,4}-?\d{4}$/;
        if (!regex.test($(this).val())) {
            alert("＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 輸入的文字須符合電話格式(且為半形文字)！")
            $(this).val("")
        }
    });

    //Email格式檢查
    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        } else {
            return true;
        }
    }

    //密碼＆再次輸入密碼 需相同
    $('#repassword').change(function() {
        var pswd = $('#password').val();
        if (pswd == $(this).val()) {} else {
            alert('密碼須相同')
            $(this).val('');
        }
    })

    $('#password').change(function() {
        var pswdre = $('#repassword').val();
        if (pswdre == $(this).val()) {} else {
            if (pswdre.length == 0) {} else {
                alert('密碼須相同')
                $('#repassword').val('');
            }
        }
    })


    // Class套用
    $('input').change(function() {
        if ($(this).val() == "") {
            $(this).removeClass('input-style-A--success')
        } else {
            $(this).addClass('input-style-A--success')
        }
    });

    $('textarea').change(function() {
        if ($(this).val() == "") {
            $(this).removeClass('input-style-A--success')
        } else {
            $(this).addClass('input-style-A--success')
        }
    });

    $('.input-style-C').focus(function() {


        $(this).parent('.input-style-C-outter').addClass('input-style-C-outter--success')

    });

    $('.input-style-C').blur(function() {

        if ($(this).val() == "") {
            $(this).parent('.input-style-C-outter').removeClass('input-style-C-outter--success')
        } else {
            $(this).parent('.input-style-C-outter').addClass('input-style-C-outter--success')
        }
    });


}


// 小視窗（dialog）開關、焦點管理、背景 inert
var smallwindowUI = (function() {
    var $dialog = null;
    var $mask = null;
    var $close = null;
    var lastFocus = null;
    var bound = false;
    var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function cache() {
        $dialog = $('.smallwindow');
        $mask = $('.smallwindow-screenmask');
        $close = $('.smallwindow__btn');
    }

    function backgroundEls() {
        return $('.skip-link, body > header, body > main').add(
            $('footer').children().not('.smallwindow, .smallwindow-screenmask')
        );
    }

    function setBackgroundHidden(hide) {
        backgroundEls().each(function() {
            if (hide) {
                this.setAttribute('inert', '');
                this.setAttribute('aria-hidden', 'true');
            } else {
                this.removeAttribute('inert');
                this.removeAttribute('aria-hidden');
            }
        });
    }

    function isOpen() {
        return $dialog && $dialog.hasClass('js-smallwindow--open');
    }

    function open(triggerEl) {
        cache();
        if (!$dialog.length) {
            return;
        }
        // 僅在使用者主動觸發時記住焦點；首頁自動開啟不記，關閉後回到頁面開頭
        lastFocus = triggerEl || null;
        $dialog.addClass('js-smallwindow--open').attr('aria-hidden', 'false');
        $mask.addClass('js-smallwindow-screenmask--active');
        setBackgroundHidden(true);
        window.setTimeout(function() {
            if ($close.length) {
                $close.trigger('focus');
            }
        }, 0);
    }

    function focusPageStart() {
        var $body = $('body');
        if ($body.attr('tabindex') == null) {
            $body.attr('tabindex', '-1');
        }
        document.body.focus({
            preventScroll: true
        });
    }

    function close() {
        cache();
        if (!$dialog.length || !isOpen()) {
            return;
        }
        $dialog.removeClass('js-smallwindow--open').attr('aria-hidden', 'true');
        $mask.removeClass('js-smallwindow-screenmask--active');
        setBackgroundHidden(false);

        var restore = lastFocus;
        lastFocus = null;

        // 還原到開啟前的觸發元素；否則把焦點放回 body，下一次 Tab 會落到 skip-link
        if (
            restore &&
            restore !== document.body &&
            typeof restore.focus === 'function' &&
            document.contains(restore) &&
            !$dialog[0].contains(restore)
        ) {
            restore.focus();
        } else {
            focusPageStart();
        }
    }

    function bind() {
        if (bound) {
            return;
        }
        bound = true;
        cache();

        $(document).off('keydown.smallwindow').on('keydown.smallwindow', function(e) {
            if (!isOpen()) {
                return;
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                close();
                return;
            }
            if (e.key !== 'Tab') {
                return;
            }
            var $focusable = $dialog.find(FOCUSABLE).filter(':visible');
            if (!$focusable.length) {
                e.preventDefault();
                if ($close.length) {
                    $close.trigger('focus');
                }
                return;
            }
            var first = $focusable.get(0);
            var last = $focusable.get($focusable.length - 1);
            var active = document.activeElement;
            if (e.shiftKey) {
                if (active === first || !$dialog[0].contains(active)) {
                    e.preventDefault();
                    last.focus();
                }
            } else if (active === last || !$dialog[0].contains(active)) {
                e.preventDefault();
                first.focus();
            }
        });

        $(document).off('click.smallwindowClose', '.smallwindow__btn')
            .on('click.smallwindowClose', '.smallwindow__btn', function(e) {
                e.preventDefault();
                close();
            });
    }

    return {
        bind: bind,
        open: open,
        close: close
    };
})();

//當區域介紹裡的項目點擊時控制小視窗開關，並載入對應資料
function smallwindow_OpenControl() {
    smallwindowUI.bind();

    $('.venueitem').off('click.smallwindowOpen').on('click.smallwindowOpen', function() {
        var target = $(this).find('.venueitem__content').html();
        $('#smallwindow-content').html(target);

        var title = $.trim($('#smallwindow-content').find('.smallwindow__title').first().text());
        $('.smallwindow').attr('aria-label', title || '訊息視窗');

        smallwindowUI.open(this);
    });
}


//進到首頁時顯示小視窗
function smallwindow_index_OpenControl() {
    smallwindowUI.bind();
    $('.smallwindow').attr('aria-label', '訊息視窗');
    smallwindowUI.open(null);
}

// 將cookie以陣列形式儲存
function parseCookie() {
    var cookieObj = {};
    var cookieAry = document.cookie.split(';');
    var cookie;

    for (var i = 0, l = cookieAry.length; i < l; ++i) {
        cookie = jQuery.trim(cookieAry[i]);
        cookie = cookie.split('=');
        cookieObj[cookie[0]] = cookie[1];
    }

    return cookieObj;
}

//讀取cookie,引數填變數名稱,會回傳值
function getCookieByName(name) {
    var value = parseCookie()[name];
    if (value) {
        value = decodeURIComponent(value);
    }

    return value;
}

function policyblock() {

    //中文版隱私權政策
    $('.block-policy--cht').html("<article class='policy_page'> <div class='policy_pageBlank'> <div class='policy_wp'> <div class='policy_content'> <div class='policy_title1'>隱私權政策 Private Policy</div> 非常歡迎您光臨「花蓮全民運動館」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容： <br><br> <div class='policy_title2'>一、隱私權保護政策的適用範圍</div> 隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。 <br> <br> <div class='policy_title2'>二、個人資料的蒐集、處理及利用方式</div> 當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。 <br> 本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。 <br> 於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。 <br> 為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。 <br> <br> <div class='policy_title2'>三、資料之保護</div> 本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。 <br> 如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。 <br> <br> <div class='policy_title2'>四、網站對外的相關連結</div> 本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。 <br> <br> <div class='policy_title2'>五、與第三人共用個人資料之政策</div> 本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。 <br> <br> 前項但書之情形包括不限於： <br> <br> 經由您書面同意。 <br> 法律明文規定。 <br> 為免除您生命、身體、自由或財產上之危險。 <br> 與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。 <br> 當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。 <br> 有利於您的權益。 <br> 本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。 <br> <br> <div class='policy_title2'>六、Cookie之使用</div> 為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導致網站某些功能無法正常執行 。<br> <br> <div class='policy_title2'>七、隱私權保護政策之修正</div> 本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。 <br> <div class='policy_page_bottom'> <input type='button' value='關閉' name='Close' class='policy_btn close_WindowBtn'> </div> </div> </div> </div> </article> <article class='policy_LinkBlank'> <div class='policy_LinkWindow'> <div class='policy_wp'> <div class='policy_title3'>隱私權政策聲明</div> <p>為達到最佳的瀏覽體驗，本網站使用cookies，若您繼續瀏覽本網站代表您同意我們的隱私權政策。</p> <div class='flexSB'> <a href='javascript:' class='policy_link window_OpenLink'> Learn more</a> <input type='button' value='好' name='Agree' class='policy_btn agree_btn'> </div> </div> </div> </article>")

    //英文版隱私權政策
    $('.block-policy--en').html(" <article class='policy_page'> <div class='policy_pageBlank'> <div class='policy_wp'> <div class='policy_content'> <div class='policy_title1'>Privacy Statement</div> <div>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. </div> <div>We may use your data in improving the user experience. By using the website and the service, you agree the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from </div> <div class='policy_part'> <div class='policy_title2'>Information Collection and Use</div> <div>We collect different types of information for various purposes to provide and improve our Website to you.</div> </div> <div class='policy_part'> <div class='policy_title2'>Types of Data Collected</div> <br/> <h5>(a)Personal Data</h5> <div>When you fill the ‘Contact Us’ form in our website, you provide us with certain personally identifiable information that can be used to contact or identify you ('Personal Data'). Personal Data be stored only if you choose to submit it to us. </div> <div>Personally identifiable information may include, but is not limited to: </div> <ul> <li>Email address</li> <li>First name and last name</li> <li>Phone number</li> <li>Address, state, province, ZIP/postal code, city and country</li> </ul> <hr> <h5>(b)Usage Data</h5> <div>We may also collect information on how the Website is accessed and used ('Usage Data'). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Website that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. </div> <hr> <h5>(c)Tracking Cookies Data</h5> <div>Cookies are small files stored on your desktop, laptop or mobile device by websites visited by you. They enable us to e.g. recognize whether there has been a previous connection between your device and our websites, take into account your preferred language or other settings, offer you certain functionalities or recognize your interests on the basis of previous use. Cookies can also contain personal information.</div> </div> <div class='policy_part'> <div>You can also visit our websites without consenting to the use of cookies by such use. In other words, you can reject the use of cookies and delete them at any time by making the appropriate settings to your device. </div> </div> <div class='policy_part'> <div class='policy_title2'>Examples of Cookies we use:</div> <ul> <li><strong>Session Cookies: </strong>We use Session Cookies to operate our Service.</li> <li><strong>Preference Cookies: </strong>We use Preference Cookies to remember your preferences and various settings.</li> <li><strong>Security Cookies: </strong>We use Security Cookies for security purposes.</li> </ul> </div> <div class='policy_part'> <div class='policy_title2'>Use of Data</div> <div>We uses the collected data for various purposes:</div> <ul> <li>To provide and maintain the Website.</li> <li>To notify you about changes to our Website.</li> <li>To allow you to participate in interactive features of our Website when you choose to do so.</li> <li>To provide customer care and support.</li> <li>To provide analysis or valuable information so that we can improve our Website to you.</li> <li>To monitor the usage of the Website.</li> <li>To detect, prevent and address technical issues.</li> </ul> </div> <div class='policy_part'> <div class='policy_title2'>Transfer of Data</div> <div>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. </div> <div>If you are located outside Taiwan and choose to provide information to us, please note that we transfer the data, including Personal Data, to Taiwan and process it there.</div> <div>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer. </div> <div>We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</div> </div> <div class='policy_part'> <div class='policy_title2'>Disclosure of Data</div> <div>We may disclose your Personal Data in the good faith belief that such action is necessary to:</div> <ul> <li>To comply with a legal obligation.</li> <li>To protect and defend the rights or property of We.</li> <li>To prevent or investigate possible wrongdoing in connection with the Website.</li> <li>To protect the personal safety of users of the Website or the public.</li> <li>To protect against legal liability.</li> </ul> </div> <div class='policy_part'> <div class='policy_title2'>Security of Data</div> <div>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security. </div> </div> <div class='policy_part'> <div class='policy_title2'>Third Party Service Providers</div> <div>We may employ third party companies and individuals to facilitate our Service ('Service Providers'), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Website is used. </div> <div>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. </div> </div> <div class='policy_part'> <div class='policy_title2'>Links to Other Sites</div> <div>Our Service may contain links to other sites, including sites provided by social media service providers, that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</div> <div>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</div> </div> <div class='policy_part'> <div class='policy_title2'>Right to Information, Correction, Deletion and Blocking of Data</div> <div>You have the right to be informed at any time about your personal data, free of charge, if you request that any incorrect information to be corrected, and any personal data should be deleted and blocked. </div> </div> <div class='policy_part'> <div class='policy_title2'>Changes to This Privacy Policy</div> <div>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. </div> <div>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</div> </div> <div><strong>Contact Us</strong><br/>If you have any questions about this Privacy Policy, please contact us. </div> <div>This Privacy Policy is updated on <strong>May. 10. 2021</strong>.</div> <div class='policy_page_bottom'> <input type='button' value='Close' name='Close' class='policy_btn close_WindowBtn'> </div> </div> </div> </div> </article> <article class='policy_LinkBlank'> <div class='policy_LinkWindow'> <div class='policy_wp'> <div class='policy_title3'>Privacy Statement</div> <div>We use cookies to improve our website, to make it easier for users to operate and to continuously upgrade. By continuing to use this page, you agree to the use of cookies.</p> <div class='flexSB'> <a href='javascript:' class='policy_link window_OpenLink'>Learn more</a> <input type='button' value='Agree' name='Agree' class='policy_btn agree_btn'></div> </div> </div> </article>")


    //使用cookie判斷 近期是否有按過同意
    var cookies = document.cookie;

    if (getCookieByName('privacy') === "true") {} else {
        $('#block-policy').show();
        $('.policy_btn.agree_btn').click(function() {
            document.cookie = 'privacy=true; max-age=259200; path=/;';
        })
    }

    //隱私權視窗
    $('.agree_btn').click(function() {
        $('.policy_LinkBlank').css('display', 'none');
    });
    $('.window_OpenLink').click(function() {
        $('.policy_LinkBlank').css('display', 'none');
        $('.policy_pageBlank').css('display', 'block');
        $('body').addClass('blackBg');
        // $("body").find('.policy_content').niceScroll({ cursorcolor: "#00A4EA", background: "#EFEFEF", cursorborder: "0.5px solid #00A4EA" });
    });
    $('.close_WindowBtn').click(function() {
        $('.policy_pageBlank').css('display', 'none');
        $('body').removeClass('blackBg');
    });
    //判斷手機版的方向(直式與橫式)
    // window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function() {
    //     if (window.orientation === 90 || window.orientation === -90) {
    //         $('.policy_content').css('max-height', '200px');
    //         $('.policy_pageBlank').css('height', '280px');
    //         //目前螢幕為橫向！
    //     }
    //     if (window.orientation === 180 || window.orientation === 0) {
    //         $('.policy_content').css('max-height', '350px');
    //         $('.policy_pageBlank').css('height', '430px');
    //         //目前螢幕為縱向！
    //     }
    // }, false);

}



// function niceScroll_initial() {
//     $('html').niceScroll({
//         cursorcolor: "#054786",
//         scrollspeed: 40, // 滾動時間
//         mousescrollstep: 45, // 滾動速度
//         cursorwidth: "8px"
//     });
// }

function recaptchaAlert() {
    alert("請勾選我不是機器人驗證，謝謝！")
}
